import {Box, FormControl, FormHelperText, Typography} from '@mui/material';
import SearchInputElement from '@jobseeker/lotus/elements/SearchInput';
import MobileSelectDialogV3 from '@jobseeker/lotus/components/MobileSelectDialog/V3';
import {VersionVariants} from '@jobseeker/lotus/enums/variants';
import {HIRISTORGANISATION, ORGANISATION} from '../../constants';
import {CourseEnquiryPopupType} from './types';
import {useState} from 'react';

const isAppHirist = process.env.NEXT_PUBLIC_APP_NAME === 'hirist';

const CurrentOrganization = (props: CourseEnquiryPopupType) => {
  const {formik, theme} = props;

  const [dialogOpen, setDialogOpen] = useState<string | false>(false);

  const error =
    formik.touched.currentOrganizationCoursePage &&
    Boolean(formik.errors.currentOrganizationCoursePage);

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'space-between',
        mt:
          formik.touched.expYearCoursePage &&
          formik.errors.expYearCoursePage?.length
            ? 0.875
            : 3,
        width: '100%',
        ...(!isAppHirist && {maxWidth: 390}),
      }}
    >
      <FormControl
        id="currentOrganizationCoursePage"
        key="currentOrganizationCoursePage"
        error={error}
        sx={{
          display: 'block',
          width: '100%',
        }}
      >
        <Typography
          sx={{
            color: '#333',
            fontSize: theme?.typography.pxToRem(14),
            fontStyle: 'normal',
            fontWeight: 500,
            lineHeight: '18px',
            mb: 1,
          }}
        >
          Current Organization&#42;
        </Typography>
        <SearchInputElement
          options={isAppHirist ? HIRISTORGANISATION : ORGANISATION}
          setDialogOpen={setDialogOpen}
          {...(process.env.NEXT_PUBLIC_APP_NAME === 'hirist' && {
            hiristColor: true,
          })}
          placeholder="Eg: Uber"
          variant={VersionVariants.VERSION_ONE}
          name="currentOrganizationCoursePage"
          key="currentOrganizationCoursePage"
          maxCharLength={100}
          value={formik.values.currentOrganizationCoursePage}
          onChange={(e: {target: {value: any}}) => {
            const selectedValue = e.target.value;

            formik.setFieldValue(
              'currentOrganizationCoursePage',
              selectedValue
            );
          }}
          onBlur={async (e: {target: {value: string}}) => {
            const selectedValue = e.target.value;
            const fieldPath = 'currentOrganizationCoursePage';

            formik.setFieldValue(fieldPath, selectedValue, false);
            await formik.validateField(fieldPath);
            formik.handleBlur(e);
          }}
          error={Boolean(
            formik.touched.currentOrganizationCoursePage &&
              formik.errors.currentOrganizationCoursePage
          )}
        />
        <MobileSelectDialogV3
          open={dialogOpen === 'currentOrganizationCoursePage'}
          onClose={() => setDialogOpen(false)}
          title="Organization"
          label="Eg: Uber"
          options={isAppHirist ? HIRISTORGANISATION : ORGANISATION}
          onChange={(value: any) => {
            formik.setFieldValue('currentOrganizationCoursePage', value, true);
          }}
          className="course-detail-page-organizations"
        />
        {error && (
          <FormHelperText>
            {formik.errors.currentOrganizationCoursePage}
          </FormHelperText>
        )}
      </FormControl>
    </Box>
  );
};

export default CurrentOrganization;
